import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import activity from '@/pages/activity'
import election from '@/pages/election'
import page_43393_41458 from '@/pages/page_43393_41458'
import activity179375 from '@/pages/activity179375'
import welcome from '@/pages/welcome'
import document from '@/pages/document'
import submission from '@/pages/submission'
import home from '@/pages/home'
import upload from '@/pages/upload'
import uploadAttachment from '@/pages/upload-attachment'
import uploadFormAttachment from '@/pages/upload-form-attachment'
import uploadSimple from '@/pages/upload-simple'
import version from '@/pages/version'
import versionMap from '@/pages/version-map'
import versionIphone from '@/pages/version-iphone'
import token from '@/pages/token'
import traffic from '@/pages/traffic'
import buyTraffic from '@/pages/buy-traffic'
import buyStorage from '@/pages/buy-storage'
import buyDownTraffic from '@/pages/buy-down-traffic'
import editor from '@/pages/editor'
import xeditor from '@/pages/xeditor'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: 'Fotoo征集一下'
      }
    },
    {
      path: '/activity/:id',
      name: 'activity',
      component: activity,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path: '/home/:userId',
      name: 'home',
      component: home,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path:'/activity/:id/election/:taskid?',
      name:'election',
      component: election,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path: '/submission/:id/:activityId?/:tmp?',
      name: 'submission',
      component: submission,
      meta: {
        title: 'Fotoo征集一下'
      }
    },
    {
      path: '/page_43393_41458',
      name: 'page_43393_41458',
      component: page_43393_41458,
      meta: {
        title: 'Fotoo征集一下'
      }
    },
    {
      path: '/activity179375',
      name: 'activity179375',
      component: activity179375,
      meta: {
        title: 'Fotoo征集一下'
      }
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: welcome,
      meta: {
        title: 'Fotoo征集一下'
      }
    },
    {
      path: '/document/:fileName?/:tmp?',
      name: 'document',
      component: document,
      meta: {
        title: 'Fotoo征集一下'
      }
    },
    {
      path: '/upload/:token/:activityId/:files/:type/:index',
      name: 'upload',
      component: upload,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path: '/upload-attachment/:token/:activityId/:files/:type/:index',
      name: 'upload-attachment',
      component: uploadAttachment,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path: '/upload-form-attachment/:token/:activityId/:files/:type/:index/inputId/:inputId',
      name: 'upload-form-attachment',
      component: uploadFormAttachment,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path: '/upload-attachment/:token/:activityId/:files/:type/:index',
      name: 'upload-attachment',
      component: uploadAttachment,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path: '/upload-simple/:token/:h5data/:tmp?',
      name: 'upload-simple',
      component: uploadSimple,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path:'/version-map/:tabCurrent',
      name:'versionMap',
      component: versionMap,
      meta: {
        title: '升级版本：开通/续费/升级',
        keepAlive: true, //此组件需要被缓存
      },
    },
    {
      path:'/version-iphone/:action?/:tmp?',
      name:'versionIphone',
      component: versionIphone,
      meta: {
        title: '升级版本',
        keepAlive: true, //此组件需要被缓存
      },
    },
    {
      path:'/version/:options?/:tmp?',
      name:'version',
      component: version,
      meta: {
        title: '升级版本：开通/续费/升级',
        keepAlive: true, //此组件需要被缓存
      },
    },
    {
      path:'/traffic/:options?/:tmp?/:tmp?',
      name:'traffic',
      component: traffic,
      meta: {
        title: '剩余云流量',
        keepAlive: true, //此组件需要被缓存
      },
    },
    {
      path:'/buy-traffic/:options?/:tmp?/:tmp?',
      name:'buy-traffic',
      component: buyTraffic,
      meta: {
        title: '购买',
        keepAlive: true, //此组件需要被缓存
      },
    },
    {
      path:'/buy-down-traffic/:options?/:tmp?/:tmp?',
      name:'buy-down-traffic',
      component: buyDownTraffic,
      meta: {
        title: '购买',
        keepAlive: true, //此组件需要被缓存
      },
    },
    {
      path:'/buy-storage/:options?/:tmp?/:tmp?',
      name:'buy-storage',
      component: buyStorage,
      meta: {
        title: '购买',
        keepAlive: true, //此组件需要被缓存
      },
    },
    {
      path:'/token/:token/:tmp?',
      name:'token',
      component: token,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path:'/editor/:id?/:tmp?',
      name:'editor',
      component: editor,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
    {
      path:'/xeditor/:objId/:id?/:tmp?',
      name:'xeditor',
      component: xeditor,
      meta: {
        title: 'Fotoo征集一下'
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js